<script>
  import { onMount } from "svelte";
  // import ProgressBar from "../components/ProgressBar.svelte";
  import { fly } from "svelte/transition";
  import { UserToken, UserData } from "../stores/LoggedUser.js";
  import { ServerRequest } from '../service/ServerRequest.js';
  import Input from "../components/form/Input.svelte";
  let token = '';
  let showPanel = false;
  
  let user = {
    nickname: '',
    name: '',
    password: '',
    device_name: 'mobile_device',
  }

  onMount( () => {
      if( $UserToken != ''  ){
        alert('You are logged in!');
        window.location.href = '#/events';
      }

      const wait = setTimeout( () => {
        showPanel = true;
        clearTimeout(wait);
      }, 525 );
  } );

  let errorBag = {};

  function signup(){

      errorBag = {};

      if(!user.name)
        errorBag.name = 'Name is required!';
      if(!user.nickname)
        errorBag.nickname = 'Nickname is required';
      if(!user.password)
        errorBag.password = 'Password is required';

      console.log(user);
      ServerRequest.post( ServerRequest.routes.save_user,token, user  )
      .then( resp => {
        if( resp.status && ( resp.data.user && resp.data.token )){
          UserData.set(resp.data.user);
          UserToken.set(resp.data.token);
          window.location.href = '#/events';
        } else if ( resp.errors ) {
          errorBag = resp.errors;
        } else {
          alert('Generic error occured, please reload and retry.');
        }
      });

  }
  
</script>

{#if showPanel }
  <div class="center" in:fly="{{ y: -400, duration: 500 }}" out:fly="{{ y: -400, duration: 500 }}">
    <div class="rpgui-container framed-golden" style="padding: 1rem .5rem">
      <h1>Chie sei?</h1>

      <div style="margin-top: 1rem">
          <Input placeholder="Name" label="{false}" name="name" id="name" bind:value="{user.name}" error="{errorBag.name}" disabled="{false}" required={true} />
      </div>
      <div style="margin-top: 1rem">
          <Input placeholder="Nickname" label="{false}" name="nickname" id="nickname" bind:value="{user.nickname}" error="{errorBag.nickname}" disabled="{false}" required={true} />
      </div>
      <div style="margin-top: 1rem">
          <Input placeholder="Password" label="{false}" inputType="password" name="password" id="password" bind:value="{user.password}" error="{errorBag.password}" disabled="{false}" required={true} />
      </div>

      <div class="text-center" style="margin-top:1.5rem">
        <button class="rpgui-button" on:click={() => signup()}>
          REGISTRATI
        </button>
      </div>

      <div class="text-center" style="margin-top:1.5rem">
        <span><a href="#/login">Login</a></span>
      </div>
    </div>
  </div>
{/if}

